import { navigateTo, simpleRoute } from '../../common/frontend/route-utils.js'
import { t } from '../../common/i18n.js'
import { Spinner } from '../components/spinner/spinner.js'
import { getBaseProps } from '../props/base.js'
import { MenuItem, View } from '../types.js'
import {
    loadPlaytimeLeaderboardIfNeeded,
    loadPlaytimeProfileIfNeeded,
} from '../utils/load-utils.js'
import { LeaderboardView } from '../views/playtime/leaderboard/leaderboard.js'

class LeaderboardModel {
    // The leaderboard lives under the badges app, not as a top-level tool.
    public route = simpleRoute<View>('/badges/leaderboard', {
        onEnter: (view) => {
            loadPlaytimeLeaderboardIfNeeded(view)
            loadPlaytimeProfileIfNeeded(view)
        },
        render: (view) => {
            const leaderboard = loadPlaytimeLeaderboardIfNeeded(view)
            const profile = loadPlaytimeProfileIfNeeded(view)
            return (
                <LeaderboardView
                    base={getBaseProps(view)}
                    leaderboard={leaderboard}
                    profile={profile}
                    currentUserId={view.state.user?.id ?? 0}
                    view={view}
                />
            )
        },
    })

    // Preserve old bookmarks: /leaderboard → /badges/leaderboard.
    public legacyRoute = simpleRoute<View>('/leaderboard', {
        onEnter: () => {
            navigateTo('/badges/leaderboard')
        },
        render: () => <Spinner />,
    })

    public menuItem: MenuItem = {
        text: t.playtime.leaderboard,
        url: this.route.toUrl(),
        matchingRoutes: [this.route],
    }
}

export const leaderboardModel = new LeaderboardModel()
